import { z } from "zod";

export const LoginRequest = z
  .object({
    email: z.email().max(254),
    password: z.string().min(1).max(500),
  })
  .strict();
export type LoginRequest = z.infer<typeof LoginRequest>;

export interface AdminMeDto {
  id: string;
  email: string;
  lastLoginAt: string | null;
}

/** Cabecera requerida en peticiones administrativas que cambian estado (mitigación CSRF junto a SameSite=Strict). */
export const CSRF_HEADER = "x-gazelab-csrf";
export const CSRF_HEADER_VALUE = "1";

export const ExcludeSession = z
  .object({
    reason: z.string().min(3).max(500),
  })
  .strict();
export type ExcludeSession = z.infer<typeof ExcludeSession>;

export const ImageReorder = z
  .object({
    order: z.array(z.uuid()).min(1).max(500),
  })
  .strict();
export type ImageReorder = z.infer<typeof ImageReorder>;

export const ImagePatch = z
  .object({
    isActive: z.boolean(),
  })
  .strict();
export type ImagePatch = z.infer<typeof ImagePatch>;

export interface ApiErrorBody {
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
}

export interface SystemInfoDto {
  version: string;
  nodeVersion: string;
  algorithmVersion: string;
  defaultRetentionDays: number;
  syntheticCaptureEnabled: boolean;
  uploadLimits: {
    maxImageSizeMb: number;
    maxImagePixels: number;
    allowedMimeTypes: string[];
    maxVideoSizeMb: number;
    /** FFmpeg disponible en el servidor (necesario para subir videos). */
    videoProcessingAvailable: boolean;
  };
  counts: { studies: number; sessions: number; syntheticSessions: number; samples: number };
  expiredSessions: number;
}

export const ALLOWED_IMAGE_MIME_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
